import { render, staticRenderFns } from "./TableImproveHistory.vue?vue&type=template&id=d7ccd86a&scoped=true&"
import script from "./TableImproveHistory.vue?vue&type=script&lang=js&"
export * from "./TableImproveHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableImproveHistory.vue?vue&type=style&index=0&id=d7ccd86a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ccd86a",
  null
  
)

export default component.exports